var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.054,
    height: 19,
    viewBox: "0 0 17.054 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screenshot-at-May-06-18-02-07",
    transform: "translate(-93.129 686.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M402.639-686.372c-.027.18-.092.615-.145.963s-.095.638-.095.638.157.027.343.056a6.5,6.5,0,0,1,4.774,3.25,6.486,6.486,0,0,1,.378,5.672c-.074.177-.139.346-.148.372s.168.121.88.417l.9.369.047-.091a8.925,8.925,0,0,0,.6-1.864,6.573,6.573,0,0,0,.145-1.654,7.552,7.552,0,0,0-.387-2.564,8.8,8.8,0,0,0-1.495-2.783,8.459,8.459,0,0,0-5.462-3.067l-.284-.041Z",
    transform: "translate(-300.134)",
    fill: "#939a9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M95.645-648.89a5.752,5.752,0,0,0-1.5,1.383,5.5,5.5,0,0,0-.99,2.47c-.171,1.371.517,3.507,1.944,6.03a23.838,23.838,0,0,0,5.368,6.594,7.356,7.356,0,0,0,1.846,1.081,5.04,5.04,0,0,0,3.914-.289c.854-.414,1.084-.65,1.087-1.108a.719.719,0,0,0-.059-.325c-.077-.174-2.869-4.263-3.013-4.417a.74.74,0,0,0-.544-.245c-.248-.015-.349.026-.851.357a3.685,3.685,0,0,1-1.817.818.71.71,0,0,1-.263-.047,7.183,7.183,0,0,1-1.7-1.74A7.217,7.217,0,0,1,97.48-641.5c.056-.411.437-.815,1.456-1.542a4.566,4.566,0,0,0,.564-.443.825.825,0,0,0,.1-.762c-.044-.115-1.034-1.583-2.742-4.077-.272-.393-.4-.514-.6-.585A.967.967,0,0,0,95.645-648.89Z",
    transform: "translate(0 -36.637)",
    fill: "#939a9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M384.266-561.045c0,.018-.059.422-.133.9s-.133.907-.133.942c0,.068.012.071.26.089a2.781,2.781,0,0,1,2.523,2.739,2.587,2.587,0,0,1-.29,1.276l-.1.2.095.038c.053.024.458.192.9.375.937.387.821.4,1-.074a4.645,4.645,0,0,0,.328-2.216,4.768,4.768,0,0,0-3.025-4A3.406,3.406,0,0,0,384.266-561.045Z",
    transform: "translate(-282.278 -121.915)",
    fill: "#939a9f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone__icon.e49ab90b9960b85617c4179af982b8f4.svg";
export { ForwardRef as ReactComponent };